<template>
  <div class="download-potential-background">
    <div class="download-potential-banner">
      <div class="download-potential-container">
        <div class="download-potential-banner-title">赝势</div>
      </div>

      <img class="download-potential-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="download-potential-container">

     <div class="download-potential-content">
       <div class="download-potential-content-title">
         <div class="download-potential-content-title-text">赝势简介</div>
         <div class="download-potential-line"></div>
       </div>
       <div class="download-potential-content-info">
         <p class="download-potential-content-info-text">目前，我们提供两种类型的赝势：模守恒赝势和超软赝势。这些赝势的格式采用的是<a class="download-potential-a" target="_blank" href="http://www.quantum-espresso.org/pseudopotentials/unified-pseudopotential-format">Quantum Espresso</a>的UPF2.0格式。我们提供的赝势库文件都是通过整理其他的开源库而来。</p>
         <p class="download-potential-content-info-text">对于模守恒赝势（Norm-Conserving Pseudopotential），我们提供了三种类型：<a class="download-potential-a" target="_blank" href="http://www.quantum-simulation.org/potentials/sg15_oncv/index.htm">SG15</a>和<a class="download-potential-a" target="_blank" href="http://www.pseudo-dojo.org/index.html">PD03</a>和<a class="download-potential-a" target="_blank" href="https://th.fhi-berlin.mpg.de/th/fhi98md/fhi98PP/">FHI</a>。其中SG15和PD03赝势都是用<a class="download-potential-a" target="_blank" href="http://www.mat-simresearch.com/">ONCVPSP</a>（Optimized Norm-Conservinng Vanderbilt PSeudopotential）产生的。SG15和PD03都是最近开发的模守恒赝势，相比以往旧的赝势，这些赝势更加精确。但是由于部分赝势包含semicores，因此需要更大截断能保证收敛。这也减慢了计算速度、增加了内存需求。FHI相比上面两种赝势较“软”，但是精度也相对低一些。</p>
         <p class="download-potential-content-info-text">对于超软赝势（Ultrasoft Pseudopotnetial），我们也提供了两种类型：USPP-SOFT和<a class="download-potential-a" target="_blank" href="http://www.physics.rutgers.edu/gbrv/">GBRV</a>。GBRV赝势也因为semicores导致截断能较大，但计算更加精确；而相对的USPP-SOFT的截断能更小一些，精度略微低。</p>
         <p class="download-potential-content-info-text">关于上面这些赝势的性能比较可以参考这篇文献：Reproducibility in density functional theory calculations of solids.K. Lejaeghere et. all, Science 25 Mar 2016, Vol. 351, Issue 6280,10.1126/science.aad3000。</p>
         <p class="download-potential-content-info-text">除此之外，我们还提供了一套SOC赝势用于非线性计算、一套H的分数赝势用于H钝化计算。</p>
         <p class="download-potential-content-info-text">20221123之后的PWmat版本支持高斯基组，我们提供高斯基组需要的BASIS和赝势，GTH_BASIS_SETS , GTH_POTENTIALS，BASIS_MOLOPT。此外，用户也可以从<a class="download-potential-a" target="_blank" href="https://github.com/cp2k/cp2k/tree/master/data">cp2k</a>网站获取。</p>
       </div>

       <div class="download-potential-content-title">
         <div class="download-potential-content-title-text">下载链接</div>
         <div class="download-potential-line"></div>
       </div>
       <div class="download-potential-download-border">

         <div class="download-potential-download-content" v-for="file in potentialDownload">
           <div ><a class="download-potential-download-text" :href='PSEDUO_DOWNLOAD+file.name'>{{file.name}}</a></div>
           <div class="download-potential-content-info-text" v-show="file.summary">{{file.summary}}</div>
         </div>

       </div>

       <div class="download-potential-content-title">
         <div class="download-potential-content-title-text">使用说明</div>
         <div class="download-potential-line"></div>
       </div>
       <div class="download-potential-content-info">
         <p class="download-potential-content-info-text">对于超软赝势，要求ECUT2L=4*ECUT2.</p>
         <p class="download-potential-content-info-text">对于大多数计算，设置ECUT2=2*ECUT就足够了，如果要求更高的计算精度，可以设置ECUT2=4*ECUT。对于镧系元素建议设置Ecut等于90~120Ryd，Ecut2=4*Ecut。</p>
         <p class="download-potential-content-info-text">对于原子弛豫，如果发现弛豫的力不再减小，也可以设置ECUT2=4*ECUT，对于更好弛豫效果（当然计算资源占用更大）可以设置ECUT2=4*ECUT，ECUT2L=4*ECUT2。</p>
         <p class="download-potential-content-info-text">对于在弛豫计算之前考虑了EGG_HEAD修正，也可以设置ECUT2=4*ECUT，ECUT2L=ECUT2。</p>
         <p class="download-potential-content-info-text">对于晶格弛豫，为了得到更合理的晶格，需要更大截断能，一般比默认的ECUT大10~20Ry就足够了。</p>
         <p class="download-potential-content-info-text">其他类型的计算，例如分子动力学计算、能带计算，可以适当的调整ECUT、ECUT2和ECUT2L的设置（减小ECUT值，减小ECUT、ECUT2、ECUT2L的倍数关系)。</p>
         <p class="download-potential-content-info-text">对于分数氢赝势，区分不同氢的方法主要是修改atom.config中的相对原子序数。无论是正常的氢赝势还是分数氢赝势，一般情况下它们的原子序数都是1。而PWmat主要是通过原子序数来对不同的赝势和原子进行匹配的。因此为了能够区分开正常的氢赝势和分数氢赝势，需要按照如下规则在atom.config文件中设置氢的原子序数：</p>

         <div class="download-potential-config-background">
           <p class="download-potential-config-text">109 --- H_0.25.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">110 --- H_0.33.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">111 --- H_0.42.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">112 --- H_0.50.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">113 --- H_0.58.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">114 --- H_0.66.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">115 --- H_0.75.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">116 --- H_1.25.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">117 --- H_1.33.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">118 --- H_1.50.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">119 --- H_1.66.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">120 --- H_1.75.SG15.PBE.UPF</p>
           <p class="download-potential-config-text">121 --- H_0.17.SG15.PBE.UPF</p>
         </div>
         <p class="download-potential-content-info-text">109 --- H_0.25.SG15.PBE.UPF意义是在atom.config中109会对应H_0.25的赝势。在解压的H.zip文件夹中有一个README.TXT说明文件供参考，也有一个example文件夹供测试。</p>

       </div>



     </div>
    </div>
  </div>
</template>

<script>
  import {PSEDUO_DOWNLOAD} from "../../helpers/consts"
  import {potentialDownload} from "../../helpers/potentialDownload"

  export default {
    name: "companyIntroduce",
    data(){
      return {
        PSEDUO_DOWNLOAD,
        potentialDownload
      }
    },
  }
</script>

<style scoped>
  .download-potential-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .download-potential-background{
    margin-top: 70px;
  }
  .download-potential-banner{
    overflow:hidden;
  }
  .download-potential-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .download-potential-banner-img{
    min-width:100%;
    height:165px;
  }
  .download-potential-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .download-potential-content-title{
    padding-top: 50px;
  }
  .download-potential-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .download-potential-content-info{
    margin-top: 40px;
  }
  .download-potential-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .download-potential-content-info-text-update{
    color:rgba(73,145,201,1);
    margin-top: 24px;
  }
  .download-potential-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .download-potential-a{
    color:rgba(73,145,201,1);
  }
  .download-potential-config-background{
    background:rgba(73,145,201,0.1);
    padding: 24px;
    margin-top: 32px;
    margin-bottom: 32px;
  }
  .download-potential-config-text{
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:18px;
  }
  .download-potential-download-border{
    background:rgba(236,244,249,1);
    padding: 24px 32px;
  }
  .download-potential-download-text{
    font-size:14px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1) !important;
    line-height:25px;
  }
  .download-potential-download-text:hover,
  .download-potential-download-text:active,
  .download-potential-download-text:focus{
    color:rgba(27,85,131,1) !important;
    text-decoration: underline;
  }
  .download-potential-download-content{
    margin-bottom: 12px;
  }

  @media screen and (max-width:482px) {
    .download-potential-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .download-potential-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .download-potential-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .download-potential-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .download-potential-container{
      max-width: 1068px;
    }
  }

</style>
